import { isFilled } from "./progress";

// Meldet eine Eingabe beim umgebenden Abschnitt an (nur im Fragebogen vorhanden).
// Der Abschnitt liest daraus den Live-Fortschritt, ohne eine Validierung
// auszulösen. Außerhalb eines Abschnitts sind die Injects null → kein Effekt.
export default {
  inject: {
    registerSectionField: { default: null },
    unregisterSectionField: { default: null },
    // Von der Schritt-Vorlage (draftModeMixin); außerhalb des Fragebogens null.
    getQuestionnaireDraftMode: { default: null },
  },

  mounted() {
    this.registerSectionField?.(this);
  },

  beforeUnmount() {
    this.unregisterSectionField?.(this);
  },

  computed: {
    /**
     * Pflicht für Validierung, Fehlerzustand, `required`-Attribut und Sternchen:
     * im Entwurfsmodus des Fragebogens nie. Ohne Provider gleich `required`.
     */
    effectiveRequired() {
      return !!this.required && !this.getQuestionnaireDraftMode?.();
    },

    // Fortschritt: zählt, was Pflicht WÄRE – unabhängig vom Entwurfsmodus.
    // Fehlt einer Komponente das Prop `required`, zählt sie nicht als Pflicht.
    sectionFieldState() {
      return { required: !!this.required && !this.disabled, filled: isFilled(this.modelValue) };
    },
  },
};
